import { qs, el } from '../lib/dom.js';
import { detectDevice, guideFor, type Device } from '../lib/device-guide.js';

const mine: Device = (location.hash.replace('#', '') as Device) || detectDevice(navigator.userAgent);
const order: Device[] = [mine, ...(['ios', 'android', 'desktop'] as Device[]).filter((d) => d !== mine)];
const wrap = qs('#guides');
for (const d of order) {
  const g = guideFor(d);
  const card = el('section', { class: 'card', id: d }, [
    el('h2', {}, [g.title + (d === mine ? ' - sizin cihazınız' : '')]),
    el('h3', {}, ['En kolay yol: kopyalayıp yapıştırın']),
    el('ol', {}, g.pasteSteps.map((s) => el('li', {}, [s]))),
    el('h3', {}, ['Dosya olarak kaydedip seçin']),
    el('ol', {}, g.steps.map((s) => el('li', {}, [s]))),
  ]);
  if (d === mine) card.style.borderColor = 'var(--accent)';
  wrap.append(card);
}
